import * as CONSTANTS from '../constants/constants';

const initialState = {
  cards: [],
};


const cards = (state = initialState, action) => {
  // console.log(action)
  switch (action.type) {
    case CONSTANTS.GET_USER_CARDS:
      return Object.assign({}, state, {
        cards: action.payload
      });
  
    default:
      return state;
  }
};

export default cards;
